/** Default letter type from GeneratorConfig.defaultDefaultLetterTypeCode */
export const DEFAULT_LETTER_TYPE_CODE = {
  code: '823691000000103',
  terms: ['Clinical letter'],
};

/** Primary SNOMED term only (no code). */
export function codePrimaryTerm(code) {
  if (!code) return '';
  const terms = code.terms;
  if (Array.isArray(terms) && terms.length > 0 && terms[0]) {
    return String(terms[0]);
  }
  return '';
}

/** Primary term with SNOMED code in parentheses, e.g. "Clinical letter (823691000000103)". */
export function formatCodeWithCode(code) {
  const term = codePrimaryTerm(code);
  if (!code?.code) {
    return term || 'not set';
  }
  if (!term) {
    return code.code;
  }
  return `${term} (${code.code})`;
}

/** Normalise a config fetch response (map or array) to a list of codes. */
export function codesFromConfigFetchResponse(data) {
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return Object.values(data);
  }
  if (Array.isArray(data)) {
    return data;
  }
  return [];
}

/** Build searchable dropdown options sorted by display label. */
export function buildCodeDropdownOptions(codes) {
  return [...codes]
    .map((c) => ({
      ...c,
      display: codePrimaryTerm(c),
    }))
    .sort((a, b) =>
      (a.display || '').localeCompare(b.display || '', undefined, { sensitivity: 'base' })
    );
}
